export enum EventStatus {
    Draft = 0,
    PendingApproval = 1,
    Scheduled = 2,
    InProgress = 3,
    Postponed = 4,
    Cancelled = 5,
    Completed = 6,
    Closed = 7
}